import classNames from 'classnames';
import styles from './ErrorCard.module.scss';
import { Heading, LinkButton, GridCell, RichText } from 'ui/components';

export interface ErrorCardProps {
	className?: string;
	heading?: string;
	kicker?: string;
	text?: string;
	link?: {
		name: string;
		target?: string;
		url: string;
	};
	settings: {
		properties?: {
			displayLinkAsButton?: boolean;
			desktopWidth?: Models.GridCellWidth;
			mobileWidth?: Models.GridCellWidth;
		};
		[key: string]: unknown;
	};
}

export const ErrorCard: React.FC<ErrorCardProps> = ({ className, heading, kicker, text, link, settings }) => {
	const { displayLinkAsButton, desktopWidth, mobileWidth } = settings?.['properties'] ?? {};
	const contentInner = (
		<div className={styles.ErrorCard_textbox}>
			<div className={styles.ErrorCard_kicker}>{kicker}</div>
			<div className={styles.ErrorCard_heading}>
				<Heading headingLevel="h1">{heading}</Heading>
			</div>
			<RichText className={classNames(styles.ErrorCard_text, 'RichText', className)} content={text} />
			{displayLinkAsButton && link && (
				<LinkButton className={styles.ErrorCard_button} style="primary">
					{link.name}
				</LinkButton>
			)}
		</div>
	);

	let content;
	if (link && !displayLinkAsButton) {
		content = (
			<a className={classNames(styles.ErrorCard, styles.ErrorCard___link, className)} href={link.url} target={link.target}>
				{contentInner}
			</a>
		);
	} else {
		content = <div className={classNames(styles.ErrorCard, className)}>{contentInner}</div>;
	}
	return (
		<GridCell desktopWidth={desktopWidth} mobileWidth={mobileWidth}>
			{content}
		</GridCell>
	);
};
